// extracted by mini-css-extract-plugin
export default {"header":"kiHzllj4qtgq2tO","buttons-container":"xGnr310Nx7q20eG","title":"IwTR8lB8fC_HV1d"};